// extracted by mini-css-extract-plugin
module.exports = {"Container":"📚4-7-03rFaN","Error":"📚4-7-02Odm8"};